import { useState } from 'react';
import useHideBottomDockModals from '~/hooks/useHideBottomDockModals';

export const useKeywordSearch = () => {
  const [inputFocus, setInputFocus] = useState(false);
  useHideBottomDockModals(inputFocus);

  return {
    inputFocus,
    setInputFocus
  };
};
